// Polyfills
import "es6-promise/auto";
import "babel-polyfill";
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import axios from "axios";
import VeeValidate from "vee-validate";
import App from "./App";
import store from "./store";
import router from "./router";
import VuesticPlugin from "@/vuestic-theme/vuestic-plugin";
import "./i18n";
import YmapPlugin from "vue-yandex-maps";
import { ClientTable } from "vue-tables-2";
import { uuid } from "vue-uuid";
import VueCurrencyFilter from "vue-currency-filter";
import VueSweetalert2 from "vue-sweetalert2";
import VueLazyLoad from "vue-lazyload";
import { havePermission } from "./util/utils";
import VueCarousel from "@chenfengyuan/vue-carousel";
import Lightbox from "vue-easy-lightbox";
import { URL_SERVER, URL_SERVER_V2 } from "./api/config";
import VueProgressBar from "vue-progressbar";
import moment from "moment";
import { integer } from "vee-validate/dist/rules.esm";
import VueSkeletonLoader from "skeleton-loader-vue";
import "sweetalert2/dist/sweetalert2.min.css";


Vue.component("vue-skeleton-loader", VueSkeletonLoader);

Vue.use(Lightbox);
Vue.use(VueProgressBar, {
  color: "blue",
  failedColor: "red",
  height: "100px"
});
Vue.use(VueCarousel);
Vue.use(VueLazyLoad);
Vue.use(VueCurrencyFilter, {
  symbol: "$",
  thousandsSeparator: ".",
  symbolSpacing: true
});
Vue.use(VueSweetalert2);
Vue.use(ClientTable);
Vue.use(VuesticPlugin);
Vue.use(YmapPlugin);
Vue.use(uuid);
Vue.directive("focus", {
  inserted: function(el) {
    el.focus();
  }
});

Vue.prototype.$axios = axios.create({ baseURL: URL_SERVER, timeout: 3600000 });
Vue.prototype.$axios2 = axios.create({
  baseURL: URL_SERVER_V2,
  timeout: 3600000
});

Vue.filter("upper", function(value) {
  return value ? value.toUpperCase() : value;
});
Vue.filter("date", function(value, format) {
  if (moment(value).format(format) === "Invalid date") return "Sin Fecha";
  if (integer(value)) return moment.unix(value).format(format);
  else return moment(value).format(format);
});
// NOTE: workaround for VeeValidate + vuetable-2
Vue.use(VeeValidate, { fieldsBagName: "formFields" });

router.beforeEach((to, from, next) => {
  store.commit("setLoading", true);
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth"
  });
  localStorage.removeItem("primera_sucursal");
  next();
});

const isLogged = function() {
  return document.cookie.replace("Token", "").replace("=", "");
};

// USUARIOS LOGEADOS
router.beforeEach((to, from, next) => {
  if (!to.meta.isPublic && !isLogged()) {
    return next({ name: "login" });
  }
  if (to.name === "dashboard" && !isLogged()) {
    return next({ name: "login" });
  }
  if (to.name === "login" && isLogged()) {
    return next({ name: "/admin/dashboard" });
  }
  if (to.name === "reset-passwordV2" && isLogged()) {
    return next();
  }
  if (!to.meta.isPublic && !havePermission(to.meta.permissions)) {
    return next({ name: "404-pages" });
  }
  return next();
});

router.afterEach((to, from) => {
  store.commit("setLoading", false);
});

const token = isLogged();

if (token) {
  axios.defaults.headers.common["X-Usuario-Nombre"] =
    window.localStorage.nombre;
  axios.defaults.headers.common["X-Usuario-Id"] =
    window.localStorage.usuario_id;
  axios.defaults.headers.common["X-Sucursal-Nombre"] =
    window.localStorage.sucursal;
  axios.defaults.headers.common["X-Sucursal-Id"] =
    window.localStorage.sucursal_id;
}

/* eslint-disable no-new */

const d = new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
});

if (token) {
  d.$axios.defaults.headers.common["X-Usuario-Nombre"] =
    window.localStorage.nombre;
  d.$axios.defaults.headers.common["X-Usuario-Id"] =
    window.localStorage.usuario_id;
  d.$axios.defaults.headers.common["X-Sucursal-Nombre"] =
    window.localStorage.sucursal;
  d.$axios.defaults.headers.common["X-Sucursal-Id"] =
    window.localStorage.sucursal_id;
  //------ v2
  d.$axios2.defaults.headers.common["X-Usuario-Nombre"] =
    window.localStorage.nombre;
  d.$axios2.defaults.headers.common["X-Usuario-Id"] =
    window.localStorage.usuario_id;
  d.$axios2.defaults.headers.common["X-Sucursal-Nombre"] =
    window.localStorage.sucursal;
  d.$axios2.defaults.headers.common["X-Sucursal-Id"] =
    window.localStorage.sucursal_id;
}

d.$axios.defaults.headers.common["Authorization"] = "Bearer " + isLogged();
d.$axios2.defaults.headers.common["Authorization"] = "Bearer " + isLogged();
axios.defaults.headers.common["Authorization"] = "Bearer " + isLogged();

const axiosSucc = response => {
  return response;
};

function validateRoute() {
  if (d.$route.name === "pagar") {
    d.$swal("Correcto!", "Venta Procesada Correctamente!", "success");
    d.$router.push("/caja/caja");
  }
}

const reTry = ({ method, url, data }) => {
  d.$axios.defaults.headers.common["Authorization"] = "Bearer " + isLogged();
  axios.defaults.headers.common["Authorization"] = "Bearer " + isLogged();
  if (data !== undefined) {
    d.$axios({ method, url, data: JSON.parse(data) }).then(() =>
      validateRoute()
    );
  } else {
    if (d.$route.name === "pagar") window.location.reload();
    if (d.$route.name === "caja") window.location.reload();
    d.$axios({ method, url }).then(() => {
      d.$forceUpdate();
    });
  }
};

const axiosErr = error => {
  if (
    error.response.status === 403 &&
    error.response.data.error === "Expired token"
  ) {
    d.$axios
      .post("usuario/refresh", {
        refresh_token: window.localStorage.refreshToken
      })
      .then(({ data }) => {
        window.localStorage.setItem("token", "Bearer " + data.token);
        reTry(error.config);
      });
  } else {
    // store.dispatch("logout").then(console.log).catch(console.error)
    return Promise.reject({ response: error.response });
  }
  return error;
};

d.$axios.interceptors.response.use(axiosSucc, axiosErr);
axios.interceptors.response.use(axiosSucc, axiosErr);
